import React, { FC, PropsWithChildren, useState, useEffect } from 'react';
import classNames from 'classnames';
import View from '../view';
import Transition, { ITransitionNameType } from '../transition';

export interface IPopupProps {
  /**
   * css class
   */
  className?: string;
  /**
   * mask css class
   */
  maskClassName?: string;
  /**
   * 是否显示
   * @default false
   */
  visible?: boolean;
  /**
   * 点击浮层的时候时候是否自动关闭
   * @default true
   */
  maskClosable?: boolean;
  /**
   * 是否显示圆角
   * @default false
   */
  round?: boolean;
  /**
   * 弹出位置
   * @default center
   */
  position?: 'top' | 'right' | 'bottom' | 'left' | 'center';
  /**
   * 是否显示关闭图标
   * @default false
   */
  closeable?: boolean;
  /**
   * 关闭图标名称或链接
   * @default close
   */
  closeIcon?: string;
  /**
   * 动画时长(ms)
   * @default 300
   */
  duration?: number;
  /**
   * 弹出层关闭时的回调
   */
  onClose?: () => void;
}

const TRANSITION_NAMES = {
  top: 'fade-down',
  right: 'fade-right',
  left: 'fade-left',
  bottom: 'fade-up',
  center: 'fade',
};

const Popup: FC<PropsWithChildren<IPopupProps>> = ({
  children,
  className,
  maskClassName,
  visible: propsVisible = false,
  maskClosable = true,
  position = 'center',
  round = false,
  closeable = false,
  closeIcon = 'close',
  duration = 300,
  onClose,
}) => {
  const [visible, setVisible] = useState(false);

  const rootClass = classNames('ink-popup', className, {
    [`ink-popup--${position}`]: true,
    'ink-popup--round': round,
  });
  const maskClass = classNames('ink-popup__overlay', maskClassName);
  const closeBtnClass = classNames('ink-popup__btn-close', 'ink-icon', `ink-icon-${closeIcon}`);

  const selfOnClose = () => {
    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };

  const onMask = () => {
    if (maskClosable) {
      selfOnClose();
    }
  };

  useEffect(() => {
    setVisible(propsVisible);
  }, [propsVisible]);

  return (
    <>
      <Transition onClick={onMask} className={maskClass} name="fade" duration={duration} visible={visible} />
      <Transition className={rootClass} name={TRANSITION_NAMES[position] as ITransitionNameType} visible={visible} duration={duration}>
        {children}
        {closeable && <View className={closeBtnClass} onClick={selfOnClose} />}
      </Transition>
    </>
  );
};

export default Popup;
